import React from 'react';

const CORE_SKILLS = [
  'Brand Design',
  'Visual Identity Systems',
  'Packaging Design',
  'Print & Digital Design',
  'Marketing Assets',
  'Presentation Design',
  'Production Artwork',
  'eCommerce Design',
  'AI-Supported Workflows'
];

const SkillsList = () => (
  <div className="mt-12 pt-8 border-t border-white">
    <p className="text-xs tracking-widest uppercase text-gray-400 mb-6" style={{ fontFamily: 'Archivo, sans-serif' }}>
      Core Skills
    </p>
    <div className="grid grid-cols-2 gap-x-8 gap-y-2">
      {CORE_SKILLS.map((skill, index) => (
        <p key={index} className="text-sm text-gray-300" style={{ fontFamily: 'Archivo, sans-serif' }}>
          • {skill}
        </p>
      ))}
    </div>
  </div>
);

const VogueAbout = () => {
  return (
    <section className="py-32 bg-black text-white">
      <div className="container mx-auto px-6 max-w-7xl">
        <div className="border-b border-white pb-8 mb-16">
          <p className="text-xs tracking-[0.3em] uppercase text-gray-400" style={{ fontFamily: 'Archivo, sans-serif' }}>
            About
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-16 max-w-6xl">
          {/* First Column with Drop Cap - BOLD */}
          <div>
            <p className="text-base leading-relaxed text-gray-200 font-bold" style={{ fontFamily: 'Archivo, sans-serif' }}>
              <span className="float-left text-7xl font-bold leading-none mr-3" style={{ fontFamily: 'Archivo, sans-serif', lineHeight: '0.8' }}>
                B
              </span>
              rand & Graphic Designer with 10+ years of experience in visual communication, brand development, and print & digital design.
            </p>
          </div>
          
          {/* Second Column - Regular Text */}
          <div>
            <p className="text-base leading-relaxed text-gray-200 mb-6" style={{ fontFamily: 'Archivo, sans-serif' }}>
              Experienced in creating and maintaining cohesive visual identities across multiple touchpoints, including branding, packaging, marketing assets, presentations, and digital content.
            </p>
            <p className="text-base leading-relaxed text-gray-200" style={{ fontFamily: 'Archivo, sans-serif' }}>
              Strong background in both conceptual design and hands-on execution, with expertise in translating strategic goals into visually compelling and production-ready creative solutions.
            </p>
            
            <SkillsList />
          </div>
        </div>
      </div>
    </section>
  );
};

export default VogueAbout;
